@if (formGroup) {
  <div class="row w-100" [formGroup]="formGroup">
    <div class="form-group {{ !!phoneNumberCssClass ? phoneNumberCssClass : (!!extensionFormControlName ? 'col-md-8' : 'w-100') }} ps-0 pe-2">
      <label>{{ 'content.phone.phone' | translate }}
        @if (readOnly) {
          <span>
            <input class="form-control phone-input" type="tel" readonly [formControlName]="phoneFormControlName" [mask]="phoneMask">
          </span>
        }
        @if (!readOnly) {
          <span>
            <app-required [control]="formGroup.controls[phoneFormControlName]"></app-required>
            <input class="form-control phone-input" type="tel" autocomplete="on" [formControlName]="phoneFormControlName" [mask]="phoneMask" #phoneFormControlNameInput>
            <app-validation-errors [displayErrors]="displayErrors" [errors]="formGroup.controls[phoneFormControlName].errors" [element]="phoneFormControlNameInput"></app-validation-errors>
          </span>
        }
      </label>
    </div>
    @if (!!extensionFormControlName) {
      <div class="form-group {{ !!extensionCssClass ? extensionCssClass : 'col-md-4' }}">
        <label>{{ 'content.phone.extension' | translate }}
          @if (readOnly) {
            <span>
              @if (readOnly) {
                <input class="form-control extension-input" type="text" mask="0000000000" readonly [formControlName]="extensionFormControlName" [validation]="false">
              }
            </span>
          }
          @if (!readOnly) {
            <span>
              <app-required [control]="formGroup.controls[extensionFormControlName]"></app-required>
              <input class="form-control extension-input"
                type="text"
                autocomplete="on"
                mask="0000000000"
                [formControlName]="extensionFormControlName"
                [validation]="false" #extensionFormControlNameInput>
                <app-validation-errors [displayErrors]="displayErrors" [errors]="formGroup.controls[extensionFormControlName].errors" [element]="extensionFormControlNameInput"></app-validation-errors>
              </span>
            }
          </label>
        </div>
      }
    </div>
  }
